export const SET_USER_BILLING_SUBSCRIPTION_PROCESSING = 'SET_USER_BILLING_SUBSCRIPTION_PROCESSING'
export const SET_USER_BILLING_SUBSCRIPTION_DATA = 'SET_USER_BILLING_SUBSCRIPTION_DATA'
export const SET_USER_BILLING_SUBSCRIPTION_ERROR = 'SET_USER_BILLING_SUBSCRIPTION_ERROR'
export const SET_USER_PAYMENT_HISTORY_PROCESSING = 'SET_USER_PAYMENT_HISTORY_PROCESSING'
export const GET_USER_PAYMENT_HISTORY_DATA = 'GET_USER_PAYMENT_HISTORY_DATA'
export const SET_USER_PAYMENT_HISTORY_DATA = 'SET_USER_PAYMENT_HISTORY_DATA'
export const SET_USER_PAYMENT_HISTORY_DATA_ERROR = 'SET_USER_PAYMENT_HISTORY_DATA_ERROR'
export const CREATE_USER_REFUND_CANCEL = 'CREATE_USER_REFUND_CANCEL'
export const RESET_USER_REFUND_CANCEL = 'RESET_USER_REFUND_CANCEL'
export const SET_USER_REFUND_CANCEL_DATA = 'SET_USER_REFUND_CANCEL_DATA'
export const SET_USER_REFUND_CANCEL_DATA_ERROR = 'SET_USER_REFUND_CANCEL_DATA_ERROR'
export const SET_USER_REFUND_CANCEL_PROCESSING = 'SET_USER_REFUND_CANCEL_PROCESSING'
export const CREATE_USER_REFUND = 'CREATE_USER_REFUND'
export const SET_USER_REFUND_PROCESSING = 'SET_USER_REFUND_PROCESSING'
export const SET_USER_REFUND_DATA = 'SET_USER_REFUND_DATA'
export const SET_USER_REFUND_DATA_ERROR = 'SET_USER_REFUND_DATA_ERROR'
export const RESET_USER_REFUND = 'RESET_USER_REFUND'
export const CREATE_USER_REFUND_DOWNGRADE = 'CREATE_USER_REFUND_DOWNGRADE'
export const SET_USER_REFUND_DOWNGRADE_PROCESSING = 'SET_USER_REFUND_DOWNGRADE_PROCESSING'
export const SET_USER_REFUND_DOWNGRADE_DATA = 'SET_USER_REFUND_DOWNGRADE_DATA'
export const SET_USER_REFUND_DOWNGRADE_DATA_ERROR = 'SET_USER_REFUND_DOWNGRADE_DATA_ERROR'
export const RESET_USER_REFUND_DOWNGRADE = 'RESET_USER_REFUND_DOWNGRADE'
export const CREATE_USER_COMP = 'CREATE_USER_COMP'
export const SET_USER_COMP_PROCESSING = 'SET_USER_COMP_PROCESSING'
export const SET_USER_COMP_DATA = 'SET_USER_COMP_DATA'
export const SET_USER_COMP_ERROR = 'SET_USER_COMP_ERROR'
export const RESET_USER_COMP = 'RESET_USER_COMP'
export const CREATE_USER_CANCEL_SUBSCRIPTION = 'CREATE_USER_CANCEL_SUBSCRIPTION'
export const SET_USER_CANCEL_SUBSCRIPTION_PROCESSING = 'SET_USER_CANCEL_SUBSCRIPTION_PROCESSING'
export const SET_USER_CANCEL_SUBSCRIPTION_DATA = 'SET_USER_CANCEL_SUBSCRIPTION_DATA'
export const SET_USER_CANCEL_SUBSCRIPTION_ERROR = 'SET_USER_CANCEL_SUBSCRIPTION_ERROR'
export const RESET_USER_CANCEL_SUBSCRIPTION = 'RESET_USER_CANCEL_SUBSCRIPTION'
export const CREATE_USER_REACTIVATE_SUBSCRIPTION = 'CREATE_USER_REACTIVATE_SUBSCRIPTION'
export const SET_USER_REACTIVATE_SUBSCRIPTION_PROCESSING =
  'SET_USER_REACTIVATE_SUBSCRIPTION_PROCESSING'
export const SET_USER_REACTIVATE_SUBSCRIPTION_DATA = 'SET_USER_REACTIVATE_SUBSCRIPTION_DATA'
export const SET_USER_REACTIVATE_SUBSCRIPTION_ERROR = 'SET_USER_REACTIVATE_SUBSCRIPTION_ERROR'
export const RESET_USER_REACTIVATE_SUBSCRIPTION = 'RESET_USER_REACTIVATE_SUBSCRIPTION'
export const GET_PLANS = 'GET_PLANS'
export const SET_PLANS_PROCESSING = 'SET_PLANS_PROCESSING'
export const SET_PLANS_DATA = 'SET_PLANS_DATA'
export const SET_PLANS_ERROR = 'SET_PLANS_ERROR'
export const CREATE_USER_PLAN_CHANGE = 'CREATE_USER_PLAN_CHANGE'
export const SET_USER_PLAN_CHANGE_PROCESSING = 'SET_USER_PLAN_CHANGE_PROCESSING'
export const SET_USER_PLAN_CHANGE_DATA = 'SET_USER_PLAN_CHANGE_DATA'
export const SET_USER_PLAN_CHANGE_ERROR = 'SET_USER_PLAN_CHANGE_ERROR'
export const RESET_USER_PLAN_CHANGE = 'RESET_USER_PLAN_CHANGE'
export const CREATE_USER_UPDATE_PAYMENT_METHOD = 'CREATE_USER_UPDATE_PAYMENT_METHOD'
export const SET_USER_UPDATE_PAYMENT_METHOD_PROCESSING = 'SET_USER_UPDATE_PAYMENT_METHOD_PROCESSING'
export const SET_USER_UPDATE_PAYMENT_METHOD_DATA = 'SET_USER_UPDATE_PAYMENT_METHOD_DATA'
export const SET_USER_UPDATE_PAYMENT_METHOD_ERROR = 'SET_USER_UPDATE_PAYMENT_METHOD_ERROR'
export const RESET_USER_UPDATE_PAYMENT_METHOD = 'RESET_USER_UPDATE_PAYMENT_METHOD'
export const SET_PAYMENT_TOKEN_PROCESSING = 'SET_PAYMENT_TOKEN_PROCESSING'
export const SET_PAYMENT_TOKEN_DATA = 'SET_PAYMENT_TOKEN_DATA'
export const SET_PAYMENT_TOKEN_ERROR = 'SET_PAYMENT_TOKEN_ERROR'
export const RESET_PAYMENT_TOKEN = 'RESET_PAYMENT_TOKEN'
export const SET_PAYMENT_BILLING_DATA = 'SET_PAYMENT_BILLING_DATA'
export const CREATE_USER_REMOVE_PAYMENT_METHODS = 'CREATE_USER_REMOVE_PAYMENT_METHODS'
export const SET_USER_REMOVE_PAYMENT_METHODS_PROCESSING =
  'SET_USER_REMOVE_PAYMENT_METHODS_PROCESSING'
export const SET_USER_REMOVE_PAYMENT_METHODS_DATA = 'SET_USER_REMOVE_PAYMENT_METHODS_DATA'
export const SET_USER_REMOVE_PAYMENT_METHODS_ERROR = 'SET_USER_REMOVE_PAYMENT_METHODS_ERROR'
export const RESET_USER_REMOVE_PAYMENT_METHODS = 'RESET_USER_REMOVE_PAYMENT_METHODS'
export const CREATE_USER_CURRENCY_CHANGE = 'CREATE_USER_CURRENCY_CHANGE'
export const SET_USER_CURRENCY_CHANGE_PROCESSING = 'SET_USER_CURRENCY_CHANGE_PROCESSING'
export const SET_USER_CURRENCY_CHANGE_DATA = 'SET_USER_CURRENCY_CHANGE_DATA'
export const SET_USER_CURRENCY_CHANGE_ERROR = 'SET_USER_CURRENCY_CHANGE_ERROR'
export const SET_USER_CURRENCY_CHANGE_POLLING = 'SET_USER_CURRENCY_CHANGE_POLLING'
export const GET_USER_CURRENCY_CHANGE_STATUS = 'GET_USER_CURRENCY_CHANGE_STATUS'
export const RESET_USER_CURRENCY_CHANGE = 'RESET_USER_CURRENCY_CHANGE'
export const SET_USER_ACCOUNT_INVOICE_HISTORY_PROCESSING =
  'SET_USER_ACCOUNT_INVOICE_HISTORY_PROCESSING'
export const GET_USER_ACCOUNT_INVOICE_HISTORY_DATA = 'GET_USER_ACCOUNT_INVOICE_HISTORY_DATA'
export const SET_USER_ACCOUNT_INVOICE_HISTORY_DATA = 'SET_USER_ACCOUNT_INVOICE_HISTORY_DATA'
export const SET_USER_ACCOUNT_INVOICE_HISTORY_DATA_ERROR =
  'SET_USER_ACCOUNT_INVOICE_HISTORY_DATA_ERROR'
export const SET_USER_ACCOUNT_INVOICE_PROCESSING = 'SET_USER_ACCOUNT_INVOICE_PROCESSING'
export const GET_USER_ACCOUNT_INVOICE_DATA = 'GET_USER_ACCOUNT_INVOICE_DATA'
export const SET_USER_ACCOUNT_INVOICE_DATA = 'SET_USER_ACCOUNT_INVOICE_DATA'
export const SET_USER_ACCOUNT_INVOICE_DATA_ERROR = 'SET_USER_ACCOUNT_INVOICE_DATA_ERROR'
export const CREATE_USER_ADJUST_PRICE = 'CREATE_USER_ADJUST_PRICE'
export const SET_USER_ADJUST_PRICE_PROCESSING = 'SET_USER_ADJUST_PRICE_PROCESSING'
export const SET_USER_ADJUST_PRICE_DATA = 'SET_USER_ADJUST_PRICE_DATA'
export const SET_USER_ADJUST_PRICE_ERROR = 'SET_USER_ADJUST_PRICE_ERROR'
export const RESET_USER_ADJUST_PRICE = 'RESET_USER_ADJUST_PRICE'
export const CREATE_USER_PAUSE_SUBSCRIPTION = 'CREATE_USER_PAUSE_SUBSCRIPTION'
export const SET_USER_PAUSE_SUBSCRIPTION_PROCESSING = 'SET_USER_PAUSE_SUBSCRIPTION_PROCESSING'
export const SET_USER_PAUSE_SUBSCRIPTION_DATA = 'SET_USER_PAUSE_SUBSCRIPTION_DATA'
export const SET_USER_PAUSE_SUBSCRIPTION_ERROR = 'SET_USER_PAUSE_SUBSCRIPTION_ERROR'
export const CREATE_USER_RESUME_SUBSCRIPTION = 'CREATE_USER_RESUME_SUBSCRIPTION'
export const SET_USER_RESUME_SUBSCRIPTION_PROCESSING = 'SET_USER_RESUME_SUBSCRIPTION_PROCESSING'
export const SET_USER_RESUME_SUBSCRIPTION_DATA = 'SET_USER_RESUME_SUBSCRIPTION_DATA'
export const SET_USER_RESUME_SUBSCRIPTION_ERROR = 'SET_USER_RESUME_SUBSCRIPTION_ERROR'
export const RESET_USER_PAUSE_RESUME = 'RESET_USER_PAUSE_RESUME'
export const GET_USER_SUBSCRIPTION_PAUSE_INFO = 'GET_USER_SUBSCRIPTION_PAUSE_INFO'
export const SET_USER_SUBSCRIPTION_PAUSE_INFO_PROCESSING = 'SET_USER_SUBSCRIPTION_PAUSE_INFO_PROCESSING'
export const SET_USER_SUBSCRIPTION_PAUSE_INFO_DATA = 'SET_USER_SUBSCRIPTION_PAUSE_INFO_DATA'
export const SET_USER_SUBSCRIPTION_PAUSE_INFO_ERROR = 'SET_USER_SUBSCRIPTION_PAUSE_INFO_ERROR'
export const RESET_USER_SUBSCRIPTION_PAUSE_INFO = 'RESET_USER_SUBSCRIPTION_PAUSE_INFO'

export function setUserBillingSubscriptionProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_BILLING_SUBSCRIPTION_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserBillingSubscriptionData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_BILLING_SUBSCRIPTION_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserBillingSubscriptionError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_BILLING_SUBSCRIPTION_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function setUserPaymentHistoryProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_PAYMENT_HISTORY_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function getUserPaymentHistoryData () {
  return {
    type: GET_USER_PAYMENT_HISTORY_DATA,
  }
}

export function setUserPaymentHistoryData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_PAYMENT_HISTORY_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserPaymentHistoryDataError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_PAYMENT_HISTORY_DATA_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function createUserRefundCancel ({ paymentId, amount, reason }) {
  return {
    type: CREATE_USER_REFUND_CANCEL,
    payload: { paymentId, amount, reason },
  }
}

export function setUserRefundCancelProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_REFUND_CANCEL_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserRefundCancelData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_REFUND_CANCEL_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserRefundCancelDataError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_REFUND_CANCEL_DATA_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetUserRefundCancel ({ storeKey }) {
  return {
    type: RESET_USER_REFUND_CANCEL,
    payload: { storeKey },
  }
}

export function createUserRefund ({ paymentId, amount, reason }) {
  return {
    type: CREATE_USER_REFUND,
    payload: { paymentId, amount, reason },
  }
}
export function setUserRefundProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_REFUND_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserRefundData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_REFUND_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserRefundDataError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_REFUND_DATA_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetUserRefund ({ storeKey }) {
  return {
    type: RESET_USER_REFUND,
    payload: { storeKey },
  }
}

export function createUserRefundDowngrade ({ paymentId, nextRatePlanId, reason, prorate }) {
  return {
    type: CREATE_USER_REFUND_DOWNGRADE,
    payload: { paymentId, nextRatePlanId, reason, prorate },
  }
}

export function setUserRefundDowngradeProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_REFUND_DOWNGRADE_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserRefundDowngradeData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_REFUND_DOWNGRADE_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserRefundDowngradeDataError ({
  storeKey,
  success,
  error,
  processing = false,
  data,
}) {
  return {
    type: SET_USER_REFUND_DOWNGRADE_DATA_ERROR,
    payload: {
      storeKey,
      success,
      error,
      processing,
      data,
    },
  }
}

export function resetUserRefundDowngrade ({ storeKey }) {
  return {
    type: RESET_USER_REFUND_DOWNGRADE,
    payload: { storeKey },
  }
}

export function createUserComp ({ reason, duration }) {
  return {
    type: CREATE_USER_COMP,
    payload: { reason, duration },
  }
}

export function setUserCompProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_COMP_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserCompData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_COMP_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserCompDataError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_COMP_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetUserComp ({ storeKey }) {
  return {
    type: RESET_USER_COMP,
    payload: { storeKey },
  }
}

export function createUserCancelSubscription () {
  return {
    type: CREATE_USER_CANCEL_SUBSCRIPTION,
  }
}
export function resetUserCancelSubscription ({ storeKey } = {}) {
  return {
    type: RESET_USER_CANCEL_SUBSCRIPTION,
    payload: { storeKey },
  }
}
export function setUserCancelSubscriptionProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_CANCEL_SUBSCRIPTION_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserCancelSubscriptionData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_CANCEL_SUBSCRIPTION_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserCancelSubscriptionError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_CANCEL_SUBSCRIPTION_ERROR,
    payload: { storeKey, error, processing },
  }
}
export function createUserReactivateSubscription () {
  return {
    type: CREATE_USER_REACTIVATE_SUBSCRIPTION,
  }
}

export function setUserReactivateSubscriptionProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_REACTIVATE_SUBSCRIPTION_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserReactivateSubscriptionData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_REACTIVATE_SUBSCRIPTION_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserReactivateSubscriptionError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_REACTIVATE_SUBSCRIPTION_ERROR,
    payload: { storeKey, error, processing },
  }
}
export function resetUserReactivateSubscription ({ storeKey }) {
  return {
    type: RESET_USER_REACTIVATE_SUBSCRIPTION,
    payload: { storeKey, error: false },
  }
}

export function getPlans () {
  return {
    type: GET_PLANS,
  }
}

export function setPlansProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_PLANS_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setPlansData ({ storeKey, data, processing = false }) {
  return {
    type: SET_PLANS_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setPlansError ({ storeKey, error, processing = false }) {
  return {
    type: SET_PLANS_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function createUserPlanChange (value) {
  return {
    type: CREATE_USER_PLAN_CHANGE,
    payload: value,
  }
}

export function setUserPlanChangeProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_PLAN_CHANGE_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserPlanChangeData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_PLAN_CHANGE_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserPlanChangeError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_PLAN_CHANGE_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetUserPlanChange ({ storeKey }) {
  return {
    type: RESET_USER_PLAN_CHANGE,
    payload: { storeKey },
  }
}

export function createUserUpdatePaymentMethod (paymentMethodId, country, postalCode) {
  return {
    type: CREATE_USER_UPDATE_PAYMENT_METHOD,
    payload: { paymentMethodId, country, postalCode },
  }
}

export function setUserUpdatePaymentMethodProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_UPDATE_PAYMENT_METHOD_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserUpdatePaymentMethodData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_UPDATE_PAYMENT_METHOD_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserUpdatePaymentMethodError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_UPDATE_PAYMENT_METHOD_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetUserUpdatePaymentMethod ({ storeKey }) {
  return {
    type: RESET_USER_UPDATE_PAYMENT_METHOD,
    payload: { storeKey },
  }
}

export function setPaymentTokenProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_PAYMENT_TOKEN_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setPaymentTokenData ({ storeKey, data, processing = false }) {
  return {
    type: SET_PAYMENT_TOKEN_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setPaymentTokenError ({ storeKey, error, processing = false }) {
  return {
    type: SET_PAYMENT_TOKEN_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetPaymentToken ({ storeKey }) {
  return {
    type: RESET_PAYMENT_TOKEN,
    payload: { storeKey },
  }
}

export function setPaymentBillingData ({ storeKey, data }) {
  return {
    type: SET_PAYMENT_BILLING_DATA,
    payload: { storeKey, data },
  }
}

export function createRemovePaymentMethods () {
  return {
    type: CREATE_USER_REMOVE_PAYMENT_METHODS,
  }
}

export function setUserRemovePaymentMethodsProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_REMOVE_PAYMENT_METHODS_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserRemovePaymentMethodsData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_REMOVE_PAYMENT_METHODS_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserRemovePaymentMethodsError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_REMOVE_PAYMENT_METHODS_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetUserRemovePaymentMethods ({ storeKey }) {
  return {
    type: RESET_USER_REMOVE_PAYMENT_METHODS,
    payload: { storeKey },
  }
}

export function createUserCurrencyChange ({ currency, latamOverride }) {
  return {
    type: CREATE_USER_CURRENCY_CHANGE,
    payload: { currency, latamOverride },
  }
}

export function resetUserCurrencyChange ({ storeKey }) {
  return {
    type: RESET_USER_CURRENCY_CHANGE,
    payload: { storeKey },
  }
}

export function setUserCurrencyChangeProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_CURRENCY_CHANGE_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserCurrencyChangeData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_CURRENCY_CHANGE_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserCurrencyChangeError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_CURRENCY_CHANGE_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function setUserCurrencyChangePolling ({ storeKey, polling = true }) {
  return {
    type: SET_USER_CURRENCY_CHANGE_POLLING,
    payload: { storeKey, polling },
  }
}

export function checkUserCurrencyChangeStatus ({ requestId }) {
  return {
    type: GET_USER_CURRENCY_CHANGE_STATUS,
    payload: { requestId },
  }
}

export function getUserAccountInvoiceHistoryData () {
  return {
    type: GET_USER_ACCOUNT_INVOICE_HISTORY_DATA,
  }
}

export function setUserAccountInvoiceHistoryProcessing ({ storeKey, processing }) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_HISTORY_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserAccountInvoiceHistoryData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_HISTORY_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserAccountInvoiceHistoryDataError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_HISTORY_DATA_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function getUserAccountInvoiceData () {
  return {
    type: GET_USER_ACCOUNT_INVOICE_DATA,
  }
}

export function setUserAccountInvoiceProcessing ({ storeKey, processing }) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserAccountInvoiceData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserAccountInvoiceDataError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_ACCOUNT_INVOICE_DATA_ERROR,
    payload: { storeKey, error, processing },
  }
}

/**
 * Creates an action to adjust a user's subscription price
 *
 * This action initiates the price adjustment process for a user's subscription.
 * It should be dispatched when an administrator wants to change a user's subscription price.
 *
 * @example
 * // Basic usage
 * dispatch(createUserAdjustPrice({
 *   price: 29.99,
 *   userInfoUuid: 'user-123',
 *   userSubscriptionNumber: 'sub-456'
 * }))
 *
 * @param {Object} params - The parameters for price adjustment
 * @param {number} params.price - The new price to set for the subscription
 * @param {string} params.userInfoUuid - The unique identifier of the user
 * @param {string} params.userSubscriptionNumber - The subscription number to adjust
 * @returns {Object} Redux action with type CREATE_USER_ADJUST_PRICE
 */
export function createUserAdjustPrice ({ price, userInfoUuid, userSubscriptionNumber }) {
  return {
    type: CREATE_USER_ADJUST_PRICE,
    payload: { price, userInfoUuid, userSubscriptionNumber },
  }
}

/**
 * Sets the processing state for the price adjustment operation
 *
 * This action is used to indicate whether a price adjustment operation is in progress.
 * It's typically used to show loading states in the UI.
 *
 * @example
 * // Show loading state
 * dispatch(setUserAdjustPriceProcessing({
 *   storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
 *   processing: true
 * }))
 *
 * // Hide loading state
 * dispatch(setUserAdjustPriceProcessing({
 *   storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
 *   processing: false
 * }))
 *
 * @param {Object} params - The parameters for setting processing state
 * @param {string} params.storeKey - The Redux store key for the adjust price state
 * @param {boolean} [params.processing=true] - Whether the operation is processing
 * @returns {Object} Redux action with type SET_USER_ADJUST_PRICE_PROCESSING
 */
export function setUserAdjustPriceProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_ADJUST_PRICE_PROCESSING,
    payload: { storeKey, processing },
  }
}

/**
 * Sets the success data for a completed price adjustment operation
 *
 * This action is dispatched when a price adjustment operation completes successfully.
 * It updates the Redux store with the operation's result data.
 *
 * @example
 * dispatch(setUserAdjustPriceData({
 *   storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
 *   data: { success: true, newPrice: 29.99 },
 *   processing: false
 * }))
 *
 * @param {Object} params - The parameters for setting success data
 * @param {string} params.storeKey - The Redux store key for the adjust price state
 * @param {Object} params.data - The success data to store
 * @param {boolean} [params.processing=false] - Whether the operation is still processing
 * @returns {Object} Redux action with type SET_USER_ADJUST_PRICE_DATA
 */
export function setUserAdjustPriceData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_ADJUST_PRICE_DATA,
    payload: { storeKey, data, processing },
  }
}

/**
 * Sets the error state for a failed price adjustment operation
 *
 * This action is dispatched when a price adjustment operation fails.
 * It updates the Redux store with the error information.
 *
 * @example
 * dispatch(setUserAdjustPriceError({
 *   storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
 *   error: 'Invalid price amount',
 *   processing: false
 * }))
 *
 * @param {Object} params - The parameters for setting error state
 * @param {string} params.storeKey - The Redux store key for the adjust price state
 * @param {string|Error} params.error - The error message or Error object
 * @param {boolean} [params.processing=false] - Whether the operation is still processing
 * @returns {Object} Redux action with type SET_USER_ADJUST_PRICE_ERROR
 */
export function setUserAdjustPriceError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_ADJUST_PRICE_ERROR,
    payload: { storeKey, error, processing },
  }
}

/**
 * Resets the state of the user's price adjustment operation
 *
 * This action is used to clear the state after a successful price adjustment
 * or when switching between different subscription management tabs.
 * dispatch(resetUserAdjustPrice({
 *   storeKey: STORE_KEY_USER_BILLING_SUBSCRIPTION_ADJUST_PRICE,
 *   data: new Map(),
 *   processing: false
 * }))
 *
 * @param {Object} params - The parameters for resetting the state
 * @param {string} params.storeKey - The Redux store key for the adjust price state
 * @param {Map} [params.data=new Map()] - Optional initial data state (Immutable Map)
 * @param {boolean} [params.processing=false] - Optional processing state
 * @returns {Object} Redux action with type RESET_USER_ADJUST_PRICE
 */
export function resetUserAdjustPrice ({ storeKey, data = new Map(), processing = false }) {
  return {
    type: RESET_USER_ADJUST_PRICE,
    payload: { storeKey, data, processing },
  }
}

export function createUserPauseSubscription ({ months }) {
  return {
    type: CREATE_USER_PAUSE_SUBSCRIPTION,
    payload: { months },
  }
}

export function setUserPauseSubscriptionProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_PAUSE_SUBSCRIPTION_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserPauseSubscriptionData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_PAUSE_SUBSCRIPTION_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserPauseSubscriptionError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_PAUSE_SUBSCRIPTION_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function createUserResumeSubscription () {
  return {
    type: CREATE_USER_RESUME_SUBSCRIPTION,
  }
}

export function setUserResumeSubscriptionProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_RESUME_SUBSCRIPTION_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserResumeSubscriptionData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_RESUME_SUBSCRIPTION_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserResumeSubscriptionError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_RESUME_SUBSCRIPTION_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetUserPauseResume ({ storeKey }) {
  return {
    type: RESET_USER_PAUSE_RESUME,
    payload: { storeKey },
  }
}

export function getUserSubscriptionPauseInfo () {
  return {
    type: GET_USER_SUBSCRIPTION_PAUSE_INFO,
  }
}

export function setUserSubscriptionPauseInfoProcessing ({ storeKey, processing = true }) {
  return {
    type: SET_USER_SUBSCRIPTION_PAUSE_INFO_PROCESSING,
    payload: { storeKey, processing },
  }
}

export function setUserSubscriptionPauseInfoData ({ storeKey, data, processing = false }) {
  return {
    type: SET_USER_SUBSCRIPTION_PAUSE_INFO_DATA,
    payload: { storeKey, data, processing },
  }
}

export function setUserSubscriptionPauseInfoError ({ storeKey, error, processing = false }) {
  return {
    type: SET_USER_SUBSCRIPTION_PAUSE_INFO_ERROR,
    payload: { storeKey, error, processing },
  }
}

export function resetUserSubscriptionPauseInfo ({ storeKey }) {
  return {
    type: RESET_USER_SUBSCRIPTION_PAUSE_INFO,
    payload: { storeKey },
  }
}
